import axios from 'axios';

const staging = 'https://api.telluswhenwhere.com';
const url = (process.env.REACT_APP_API_BASE || staging).replace(/\/+$/, '');
const CLIENT_ID_STORAGE_KEY = 'tellus.react.client_id';
const API_TIMEOUT_MS = Number(process.env.REACT_APP_API_TIMEOUT_MS || 8000);

function randomSegment() {
  return Math.random().toString(36).slice(2, 10);
}

export function getTellusClientId() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return 'tellus-react-client';
  }

  const existing = window.localStorage.getItem(CLIENT_ID_STORAGE_KEY);
  if (existing) return existing;

  const generated = `trc-${randomSegment()}${randomSegment()}`;
  window.localStorage.setItem(CLIENT_ID_STORAGE_KEY, generated);
  return generated;
}

function jsonHeaders() {
  return {
    'Content-Type': 'application/json',
    'X-Client-Id': getTellusClientId(),
  };
}

function requestOptions() {
  return {
    headers: jsonHeaders(),
    timeout: API_TIMEOUT_MS,
  };
}

export const getMultiSpecies = (page, searchQuery) =>
  axios.post(
    `${url}/tellus/species/get`,
    { page: page, search_query: searchQuery },
    requestOptions()
  );

export const getOneSpecies = (id) =>
  axios.get(`${url}/tellus/species/${id}`, requestOptions());


export const getEvents = (page, taxonKey) => axios.post(
  `${url}/tellus/events/get`,
  {
    page: page,
    tag: taxonKey || undefined,
  },
  requestOptions()
);
export const getEvent = (id) => axios.post(
  `${url}/tellus/events`,
  { id },
  requestOptions()
);

export const getHotspots = (page, taxonKey) =>
  axios.post(
    `${url}/tellus/hotspots/get`,
    { taxon_key: taxonKey, page: page },
    requestOptions()
  );
export const getHotspot = (id) => axios.post(
  `${url}/tellus/hotspots`,
  { id },
  requestOptions()
);

export const getUpcomingEvents = ({
  lat,
  lon,
  radiusKm = 50,
  days = 14,
  interests = [],
  categories = [],
}) => {
  const params = new URLSearchParams({
    lat: String(lat),
    lon: String(lon),
    radius_km: String(radiusKm),
    days: String(days),
  });

  const interestList = Array.isArray(interests) ? interests.filter(Boolean) : [];
  const categoryList = Array.isArray(categories) ? categories.filter(Boolean) : [];

  if (interestList.length) params.set('interests', interestList.join(','));
  if (categoryList.length) params.set('categories', categoryList.join(','));

  return axios.get(`${url}/tellus/events/upcoming?${params.toString()}`, {
    ...requestOptions(),
  });
};

export const getMarineSpeciesChecklist = ({ lat, lon, date, intent = 'observe' }) =>
  axios.get(
    `${url}/tellus/marine/species-checklist?lat=${encodeURIComponent(lat)}&lon=${encodeURIComponent(
      lon
    )}&date=${encodeURIComponent(date)}&intent=${encodeURIComponent(intent)}`,
    requestOptions()
  );

export const getMarineWildlifeContext = ({ lat, lon, date }) =>
  axios.get(
    `${url}/tellus/marine/wildlife-context?lat=${encodeURIComponent(lat)}&lon=${encodeURIComponent(
      lon
    )}&date=${encodeURIComponent(date)}`,
    requestOptions()
  );
